import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import {
  API_SCORECARD_GOAL_COMMENT_THREAD,
  API_SCORECARD_SUBGOAL_COMMENT_THREAD,
} from 'constants/api';
import { generateURL } from 'helpers';
import { ScorecardsActionStoreArgument } from 'store/interfaces';
import { updateScorecardCommentsThread } from 'store/scorecards';
import { storeName } from '../config';
import { Thread } from '../interfaces';

export const createScorecardThread = createAsyncThunk<
  Thread,
  {
    scorecardId: number;
    goalId: number;
    subgoalId?: number;
    store: ScorecardsActionStoreArgument;
  }
>(
  `${storeName}/createScorecardThread`,
  ({ scorecardId, goalId, subgoalId, store }, thunkAPI) => {
    const url = subgoalId
      ? API_SCORECARD_SUBGOAL_COMMENT_THREAD
      : API_SCORECARD_GOAL_COMMENT_THREAD;
    return api.axios
      .post<Thread>(
        generateURL(url, { scorecardId, goalId, subgoalId: subgoalId || '' }),
        {},
      )
      .then((res) => {
        thunkAPI.dispatch(
          updateScorecardCommentsThread({
            store,
            scorecardId,
            goalId,
            subgoalId,
            thread: { id: res.data.id, totalMessages: res.data.totalMessages },
          }),
        );
        return res.data;
      })
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data));
  },
);
